import type { CustomIconLibrary } from '@/api';
import { faIcons } from '@/common/font-awesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';

export type CustomIcon = { library: CustomIconLibrary; name: string };
export type CustomIconDefinition = CustomIcon & { icon: IconDefinition };

const fallbackIcon = faCircleQuestion;
if (!fallbackIcon) {
  throw new Error('No fallback icon found.');
}

export const getCustomIcon = (icon: CustomIcon) => {
  const faIcon = faIcons.find((definition) => definition.library === icon.library && definition.name === icon.name);
  if (faIcon) {
    return faIcon.icon;
  }

  console.warn(`Custom icon ${icon.library}/${icon.name} was not found.`);
  return fallbackIcon;
};
